export default (pubId) => {
  if (document.querySelector("#addThisScript")) {
    return false;
  }

  const script = document.createElement("script");
  script.setAttribute("id", "addThisScript");
  script.setAttribute(
    "src",
    `https://static.addtoany.com/menu/page.js`,
  );
  document.querySelector("body").append(script);
};
